import React, { useState } from 'react';
import classNames from 'classnames';
import Image from '../Image';
import Video from '../Video';
import Button from '../Button';
import './styles.scss';

const VTSPlayer = ({ seriesTitle, episodes, educatorGuide }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = episodes[activeIndex];

  return (
    <div className="vts-player">
      {seriesTitle && <h2 className="vts-player__series-title">{seriesTitle}</h2>}
      <div className="vts-player__layout">

        {/* ── Left: main player ─────────────────────────────── */}
        <div className="vts-player__main">
          <Video
            src={active.src}
            title={active.title}
            className="vts-player__video"
          />
          <div className="vts-player__active-info">
            <h3 className="vts-player__active-title">{active.title}</h3>
            {active.duration && (
              <span className="vts-player__active-duration">
                Full Video | {active.duration}
              </span>
            )}
            {active.description && (
              <p className="vts-player__active-description">{active.description}</p>
            )}
            {active.activityHref && (
              <Button
                to={active.activityHref}
                target="_blank"
                rel="noopener noreferrer"
                className="vts-player__activity-btn"
              >
                Student Activity
              </Button>
            )}
          </div>
        </div>

        {/* ── Right: episode list + guide ───────────────────── */}
        <div className="vts-player__sidebar">
          <div className="vts-player__episodes">
            {episodes.map((ep, i) => (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className={classNames(
                  'vts-episode',
                  i === activeIndex && 'vts-episode--active'
                )}
                aria-label={`Play episode: ${ep.title}`}
                aria-pressed={i === activeIndex}
              >
                <div className="vts-episode__thumb">
                  <Image filename={ep.thumbnail} alt={ep.title} />
                </div>
                <div className="vts-episode__meta">
                  <strong className="vts-episode__title">{ep.title}</strong>
                  {ep.duration && (
                    <span className="vts-episode__duration">{ep.duration} min</span>
                  )}
                  {ep.shortDescription && (
                    <p className="vts-episode__desc">{ep.shortDescription}</p>
                  )}
                </div>
              </button>
            ))}
          </div>

          {educatorGuide && (
            <div className="vts-player__guide">
              <h4 className="vts-player__guide-heading">Educator Guide</h4>
              {educatorGuide.description && (
                <p className="vts-player__guide-desc">{educatorGuide.description}</p>
              )}
              <Button
                to={educatorGuide.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                Download Guide
              </Button>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default VTSPlayer;
